import React from 'react';
import './HomeUsers.scss'
import {useNavigate} from 'react-router-dom';

export const HomeUsersComponent = () => {
    const userButton = () => {
        navigate('/home/users')
    }
    const navigate = useNavigate();

    return (
        <>
            <div className="button-card-body">
                <div className="icona_omino"></div>
                <button className="card-button" onClick={userButton}>
                    Gestione Utenti
                </button>
                <p>
                    Accedi al cruscotto di configurazione per la gestione delle utenze in possesso dei dispositivi
                    Atmotube
                </p>
            </div>
        </>
    );
};


